import React from 'react';
import Form from 'react-bootstrap/Form';
import SimpleBar from 'simplebar-react';

import { FILTER_GROUPS, DEFAULT_LANG } from '../Utilities/Config';

import 'simplebar-react/dist/simplebar.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Filter.css';

export default function Filter(props) {
	const { show, onToggle, language, categories, setActiveCategories, activeLanguage } = props;

	const toggleLayers = (e) => {
		let newObject = JSON.parse(JSON.stringify(categories));
		let toggleId = e.target.id;
		newObject[toggleId].state = !!e.target.checked;
		setActiveCategories(newObject);
	}

	const categoriesList = () => {
		if (!categories) return;

		// generate toggles themselves
		return Object.entries(categories).map(([categoryId, categoryData], index) => {

			const color = categoryData.color;
			const state = categoryData.state;
			const langPrefix = (activeLanguage && activeLanguage !== DEFAULT_LANG);
			const title = (langPrefix) ? categoryData[`name_${activeLanguage}`] : categoryData.name;

			return (
				<div className='toggle-block-wrapper' key={categoryId}>
					<div className='toggle-wrapper'>
						<div className='toggle-icon' style={{backgroundColor: color}}></div>
						<div className='toggle-label'>
							<div className='toggle-title'>{title}</div>
							{/*<div className='toggle-description'>{shortDescription}</div>*/}
						</div>
						<Form.Check
							key={`${categoryId}_${index}`}
							id={categoryId}
							className='filter-toggle'
							type='switch'
							aria-label={title}
							checked={state}
							onChange={toggleLayers}
						/>
					</div>
				</div>
			);
		});
	}

	const categoriesGroup = FILTER_GROUPS[1];
	const layerGroupName =
		(language) ? (
			(language[`layers:group:${categoriesGroup}`])
			? language[`layers:group:${categoriesGroup}`]
			: categoriesGroup
		) : categoriesGroup;

	return (
		<div className='filter-window-wrapper'>
			<div className={`filter-window ${(show) ? 'show' : ''}`}>
				<div className='filter-header'>
					<div className='button-close' onClick={onToggle}></div>
				</div>
					<SimpleBar
						autoHide={false}
						style={{ maxHeight: 300 }}
					>
						<div className='content'>
							<div className="filter-group">
								<div className="filter-group-title">{layerGroupName}</div>
								<div className="filter-group-toggles">{categoriesList()}</div>
							</div>
						</div>
					</SimpleBar>
			</div>
		</div>
	);

}
